import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container p-5" }
const _hoisted_2 = { class: "d-flex mobile-column" }
const _hoisted_3 = { class: "my-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "nicki_minaj_event_name",
  class: "me-3"
}, "Current event name", -1)
const _hoisted_5 = { class: "my-3" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "nicki_minaj_website_enabled"
}, " Uploads enabled ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "my-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-dark py-2 px-5 rounded-0" }, " Save ")
], -1)

import {onMounted} from "vue";
import {useRoute} from "vue-router";
import {useRouter} from "vue-router";
import {Field} from "vee-validate";
import {ErrorMessage} from "vee-validate";
import {useForm} from "vee-validate";
import * as Yup from "yup";
import {LpApiService} from "@/services/lpApiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'Admin',
  setup(__props) {


const route = useRoute()
const router = useRouter()

onMounted(async () => {
  if (route.query['key'] != ')!Udlaskjdkj') {
    router.push('/')
  }

  const settings = await LpApiService.getSetting()
  setValues(settings)
})

const {values, handleSubmit, setValues} = useForm({
  validationSchema: Yup.object().shape({
    nicki_minaj_event_name: Yup.string().required("Please enter the current event name"),
  })
})
const onFormSubmit = handleSubmit(async (values) => {
  try {
    console.log(values)

    await LpApiService.saveSettings(values)
  } catch (e) {
    alert('Error')
  } finally {
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          action: "",
          onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onFormSubmit) && _unref(onFormSubmit)(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(Field), { name: "nicki_minaj_event_name" }),
            _createElementVNode("div", null, [
              _createVNode(_unref(ErrorMessage), {
                name: "nicki_minaj_event_name",
                class: "fv-plugins-message-container text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Field), {
                class: "form-check-input",
                type: "checkbox",
                value: true,
                "unchecked-value": false,
                id: "nicki_minaj_website_enabled",
                name: "nicki_minaj_website_enabled"
              }),
              _hoisted_7
            ])
          ]),
          _hoisted_8
        ], 32)
      ])
    ])
  ]))
}
}

})